<ng-container *ngTemplateOutlet="navbar"></ng-container>
<!-- <div class="pointer swhat-icon website-what-icon" (click)="openSupport()" matTooltip="WhatsApp Support">
  <img class="icon-40" src="https://storage.googleapis.com/airlift-images/atmavaan_images/Whatsapp_Icon.png">
</div> -->

<div class="pointer swhat-icon box-s1 bg-white grid  grid-gap-10 align-c pad-5-10" matRipple
  style="grid-template-columns: 30px auto;border-radius: 24px;" (click)="openSupport()" matTooltip="Talk to a real specialist on a whatsapp chat" matTooltipPosition="above">
  <img class="icon-30" src="https://app.atmavaan.com/uploads/whatsapp_logo__png_2_2024-09-16_14:06:30.png" alt="Chat" width="30" height="30" decoding="async">
  <span class="head-c f-w-500">Chat</span>
</div>

<ng-template #navbar>
  <!-- {{(tabName=='home') ? 'land-bg' : 'box-s3'}} -->
  <mat-toolbar class="flex justify-c nav-toolbar pad-0 {{tabName=='home' || tabName==null || tabName=='' ? 'land-bg pad-50-res pad-lr-30-r-home' : 'box-s3'}} {{scrollValueShown  ? 'box-s3 pad-0' : ''}}">
    <!-- {{tabName!='home' ? 'app-primary-c' : ''}} -->
    <mat-toolbar-row id="website-nav-bar" class="flex align-c justify-space-between pad-lr-30-r app-primary-c">
      <div class="flex align-c justify-c">
        <!-- <button mat-icon-button class="icon-btn-basic" (click)="sidenav.toggle()" fxShow="true" fxHide.gt-sm
          class="menu-btn-marl-5">
          <mat-icon class="white-text">menu</mat-icon>
        </button> -->
        <div class="width-100 mar-left-10 flex align-c pointer" routerLink="" (click)="homeRoute()">
          <!-- <div class="mar-r-10  mar-t-10"><img loading="lazy" class="logo"
              src="https://app.atmavaan.com/uploads/Atmavaan_Logo_40x40_svg_2_2023-12-05_05:37:46.svg"></div> -->
          <div class=""><img class="logo" alt="Atmavaan" width="45" height="45"
              src="assets/icons/atmavaan-logo-navbar.png">
          </div>
          <!-- <div class="flex flex-d-c">
            <span class="font-25-res f-w-b white-text">Atmavaan</span>
            <span class="font-12 line-h-24 white-text opac-06 desk-view">Ship Fast, Ship Smart</span>
          </div> -->
        </div>
      </div>

      <!--  nav bar starts -->

      <div class="flex justify-c nav-lg-only">

        <div *ngFor="let item of menuList;index as indexAs" class="drop" (click)="getTabName()">
          <a [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" *ngIf="!!item?.isroute"
            routerLink="{{item.link}}"
            class="mar-lr-10 font-14 pad-lr-10 pos-r menuitem dropdown pointer {{'s'+indexAs}} white-text"
            (click)="updateActiveSubtab('');routePage(item)"
            appEventTracker="nav_{{item?.link}}" [module]="'navigation'" [eventAction]="'navigation'"
            [trackingData]="{to: item?.name, link: item?.link === '/' ? '' : item?.link}">{{item?.name}}
            <div class="active-dot"></div>
          </a>

          <a *ngIf="!item?.isroute" [routerLinkActive]="'active'" role="button"
            class="mar-lr-10 font-14 f-w-400 pad-lr-10  menuitem dropdown {{'s'+indexAs}} expand">
            <div class="pointer flex align-c white">
              <div class="white-text">{{item?.name}}</div>
              <mat-icon class="flex-a font-18" id="expandIcon">expand_more</mat-icon>
            </div>

            <!-- <div class="service-menu grid grid-50-50 dr-menu" style="left: -175px;line-height: 30px;"
              *ngIf="item.key === 'service'">
              <div *ngFor="let serviceitem of servicesData" class="width-m mar-l-5">
                <div class="pointer" routerLink="{{serviceitem.route}}" (click)="updateActiveSubtab(serviceitem.route)">
                  <div class="font-14 f-w-500 text-a-l s-title flex align-c">
                    <img alt="{{serviceitem.alt}}" src="{{serviceitem.img}}" class="mar-r-10">
                    {{serviceitem.title}}
                  </div>
                  <p class="font-12 nav-desc" align="left">{{serviceitem.description}}</p>
                </div>
              </div>
            </div> -->

            <div class="service-menu dr-menu"
              style="left: -175px;line-height: 30px;padding: 0!important;max-height: none!important;"
              *ngIf="item.key === 'service'">
            
              <div style="padding: 20px;">
                <h4 style="text-align: left; color: black; font-weight: 400;margin-bottom: 10px;font-size: 16px;">Primary Services
                </h4>
                <div class="grid grid-50-50" style="grid-row-gap: 15px;">
                  <div *ngFor="let serviceitem of servicesData.primary" class="service-item pointer"
                    style="display: flex; gap: 10px; align-items: center;" [routerLink]="serviceitem.route || ''"
                    (click)="updateActiveSubtab(serviceitem.route || '')">
                    <div class="icon-box"
                      style="padding: 10px; align-items: center; background: #1E3D62; display: flex; border-radius: 4px;">
                      <span class="material-symbols-outlined" style="color: #E8A23D;">{{serviceitem.icon}}</span>
                    </div>
                    <span class="service-label" style="color: #28323c; font-size: 14px;">{{serviceitem.title}}</span>
                  </div>
                </div>
              </div>
            
              <div style="height: 0.5px;width: 100%;background: #E1E1E1;"></div>
            
              <div style="padding: 20px;">
                <h4 style="text-align: left; color: black; font-weight: 400;margin-bottom: 10px;font-size: 16px;">Additional
                  Services</h4>
                <div class="grid grid-50-50" style="grid-row-gap: 15px;">
                  <div *ngFor="let serviceitem of servicesData.additional" class="service-item pointer"
                    style="display: flex; gap: 10px; align-items: center;" [routerLink]="serviceitem.route || ''"
                    (click)="updateActiveSubtab(serviceitem.route || '')">
                    <div class="icon-box"
                      style="padding: 10px; align-items: center;background-color: #1E3D62; display: flex; border-radius: 4px;">
                      <span class="material-symbols-outlined"  style="color: #E8A23D;">{{serviceitem.icon}}</span>
                    </div>
                    <span class="service-label" style="color: #28323c; font-size: 14px;">{{serviceitem.title}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="pad-lr-10 dr-menu" style="left: -162px;line-height: 30px;color: black;text-align: left;width: 420px;padding: 12px;" *ngIf="item.key === 'tools'">
              <div style="margin-left: 10px;font-size: 16px;margin-bottom:15px;">Tools</div>
              <div style="display:grid;grid-template-columns:auto auto;">
              <div *ngFor="let item of toolsSubTab">
                <div matRipple
                  class="flex align-c pad-lr-10 pointer mar-b-10 pad-5-10 "
                  routerLink="{{item.route}}" (click)="updateActiveSubtab(item.route);congetStarted(item.route)">
                  <!-- <div class="tab-icon" [ngStyle]="{'background-position':item.tb + ' ' + item.lr }"></div> -->
                  <div *ngIf="item.img" style="display:flex;align-items:center;background-color: #1E3D62;padding:15px;border-radius:4px;"><img  [ngStyle]="{'width':item.width}" src="{{item.img}}" [alt]="item.name + ' icon'" style=" filter: brightness(0) saturate(100%) invert(73%) sepia(49%)
          saturate(1187%) hue-rotate(345deg) brightness(96%) contrast(92%);;margin: 0!important;"
                    class="{{item.name != 'Container Tracking' && item.name != 'Vessel Schedule' ? 'mar-r-10' : 'mar-r-5 icon-16'}}"></div>
                    <div *ngIf="item.icon" style="display:flex;align-items:center;background-color: #1E3D62;padding: 11px;border-radius:4px;">
                      <span *ngIf="item.icon !== 'custom_half_arrows'"  class="material-symbols-outlined" style="color: #E8A23D;">
                      {{ item.icon }}
                      </span>
                      <svg *ngIf="item.icon === 'custom_half_arrows'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="#E8A23D" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                        style="cursor: pointer;" style="color: #E8A23D;">
                        <path d="M20 9H4l5-5"></path>
                      
                        <path d="M4 15h16l-5 5"></path>
                      </svg>
                    </div>
                  <div class="pad-lr-10 font-14 subc-b" >{{item?.name}}</div>
                </div>
              </div>
              </div>
            </div>

            <div class="pad-lr-10 dr-menu" style="left: -162px;line-height: 30px;color: black;text-align: left;width: 420px;padding: 12px;" *ngIf="item.key === 'resources'">
              <div style="margin-left: 10px;font-size: 16px;margin-bottom:15px;">Resource</div>
              <div style="display:grid;grid-template-columns:auto auto;">
              <div *ngFor="let item of resourceTab">
                <div matRipple
                  class="flex align-c pad-lr-10 pointer mar-b-10 pad-5-10 "
                  routerLink="{{item.route}}" (click)="updateActiveSubtab(item.route);congetStarted(item.route)">
                  <!-- <div class="tab-icon" [ngStyle]="{'background-position':item.tb + ' ' + item.lr }"></div> -->
                  <!-- <div *ngIf="item.img" style="display:flex;align-items:center;background-color: #EFF6FF;padding:15px;border-radius:4px;"><img  [ngStyle]="{'width':item.width}" src="{{item.img}}" alt="Icon" style="filter: invert(27%) sepia(94%) saturate(3000%) hue-rotate(215deg) brightness(0.95);margin: 0!important;"
                    class="{{item.name != 'Container Tracking' && item.name != 'Vessel Schedule' ? 'mar-r-10' : 'mar-r-5 icon-16'}}"></div> -->
                    <div *ngIf="item.icon" style="display:flex;align-items:center;background-color: #1E3D62;padding: 11px;border-radius:4px;">
                      <span *ngIf="item.icon !== 'custom_half_arrows'"  class="material-symbols-outlined" style="color: #E8A23D;">
                      {{ item.icon }}
                      </span>
                      <svg *ngIf="item.icon === 'custom_half_arrows'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                        style="cursor: pointer;"  style="color: #E8A23D;">
                        <path d="M20 9H4l5-5"></path>
                      
                        <path d="M4 15h16l-5 5"></path>
                      </svg>
                    </div>
                  <div class="pad-lr-10 font-14 subc-b" >{{item?.name}}</div>
                </div>
              </div>
              </div>
            </div>

            <div class="pad-lr-10 dr-menu" style="left: -250px;line-height: 30px;color: black;text-align: left;width: 560px;padding: 20px;" *ngIf="item.key === 'shippingLiners'">
              <div class="flex align-c justify-space-between">
                <div>
                  <div style="font-size:16px;font-weight:600;color:#111f3c;">Shipping Line Schedules</div>
                  <div style="font-size:12px;color:#556176;margin-top:2px;">Live sailing schedules from {{shippingLinersList.length}} global carriers</div>
                </div>
                <div style="background:#E8F7EE;color:#1F9254;font-size:11px;font-weight:600;padding:4px 10px;border-radius:12px;white-space:nowrap;">● Live Schedules</div>
              </div>

              <div style="height:0.5px;width:100%;background:#E1E1E1;margin:14px 0;"></div>

              <div style="display:grid;grid-template-columns:repeat(3, 1fr);gap:12px 16px;">
                <div *ngFor="let liner of shippingLinersList" class="service-item pointer"
                  style="display:flex;gap:10px;align-items:center;" [routerLink]="'/port-to-port/' + liner.slug"
                  (click)="updateActiveSubtab('port-to-port/' + liner.slug)">
                  <img [src]="liner.logo" [alt]="liner.name" loading="lazy"
                    style="width:28px;height:28px;object-fit:contain;border-radius:4px;flex-shrink:0;">
                  <span class="service-label" style="color:#28323c;font-size:14px;">{{liner.name}}</span>
                </div>
              </div>

              <div style="height:0.5px;width:100%;background:#E1E1E1;margin:16px 0 10px;"></div>

              <div class="flex align-c justify-space-between">
                <span style="font-size:11px;color:#8a94a6;">Updated daily · All India-USA trade lanes</span>
                <button mat-flat-button class="signup-btn" style="font-size:12px;padding:0 14px;height:32px;line-height:32px;"
                  routerLink="tools/vessel-schedules" (click)="updateActiveSubtab('tools/vessel-schedules')">Get an instant rate</button>
              </div>
            </div>

            <!-- <div class="pad-lr-10 dr-menu" style="left: -20px;line-height: 30px;" *ngIf="item.key === 'company'">
              <div *ngFor="let item of companySubTab">
                <div
                  class="flex align-c pad-lr-10 pointer color-b pad-5-10 {{item.name == 'About us' ? 'mar-t-5 mar-b-10' : 'mar-b-10'}}"
                  routerLink="{{item.route}}" (click)="updateActiveSubtab(item.route)">
                  <div class="tab-icon" [ngStyle]="{'background-position':item.tb + ' ' + item.lr }"></div>
                  <div class="pad-lr-10 font-12 subc-b">{{item?.name}}
                  </div>
                </div>
              </div>
            </div> -->

            <div class="active-dot"></div>
          </a>
        </div>
      </div>

      <!--  nav bar end -->

      <div
        class="flex align-c {{tabName=='home' || tabName==null ?'':'mar-r-20'}} {{scrollValueShown ? 'mar-r-20' : ''}}">
        <div *ngIf="authChecked && !!userInfo" class="nav-lg-only border-c flex align-c border-r-4 pointer pad-4-10" matRipple
          [matMenuTriggerFor]="profileOptionMenu">
          <div class="white flex-d-c flex align-e mar-r-10 overflow-e line-16">
            <span class="font-12 f-w-500">{{userInfo.user_name}}</span>
            <span class="font-10">{{!!selectedCompany?.company_name?selectedCompany?.company_name:'---'}}</span>
          </div>
          <div class="flex align-c justify-c">
            <ng-container *ngTemplateOutlet="profileIcon"></ng-container>
          </div>
          <!-- <mat-icon class="icon-20">expand_more</mat-icon> -->
        </div>
        <!-- shown only when logged out; fxHide + [style.display] both wrote `display`, so after login the buttons sometimes came back -->
        <!-- rendered (invisible) before the auth check too, so the centred menu doesn't shift when they appear -->
        <button *ngIf="!authChecked || !isUserLoggedIn" mat-button class="mar-r-16 btn-text nav-lg-only" [style.visibility]="authChecked ? 'visible' : 'hidden'" (click)="login()" >
          Login
        </button>
        <!-- <button mat-button class="mar-r-16 btn-text" style="border-radius: 10px; border:1px solid #FFFFFF47;" fxHide.lt-md [routerLink]="'contact-us'" *ngIf="!userInfo">
          Talk to a specialist
        </button> -->
        <!-- the filled button is the quote: most visitors want a price, not an account -->
        <button *ngIf="!authChecked || !isUserLoggedIn" mat-button class="mar-r-16 btn-text nav-lg-only" [style.visibility]="authChecked ? 'visible' : 'hidden'" (click)="signup()">Sign Up</button>
        <button mat-flat-button class="signup-btn nav-lg-only" (click)="openQuote()"
          appEventTracker="get_quote_navbar" [module]="'navbar'" [eventAction]="'get_quote'">Get a quote</button>

        <button mat-icon-button class="icon-btn-basic menu-btn-marl-5 nav-sm-only" (click)="toggleSidenav()"
          [attr.aria-label]="isSidenavOpen ? 'Close menu' : 'Open menu'">
          <mat-icon class="white-text">
            {{ isSidenavOpen ? 'close' : 'menu' }}
          </mat-icon>
        </button>

        <!-- <div class="flex justify-r pad-r-10">
          <button mat-icon-button class="icon-btn-basic" (click)="sidenav.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div> -->
        <!-- <button mat-button style="min-width: 10px; background-color: #3889fa;" (click)="login()" *ngIf="!userInfo">
          <mat-icon class="icon-25 white" style="margin: 0;">person</mat-icon>
        </button> -->
        <!-- <div>Login</div> -->

      </div>

    </mat-toolbar-row>

  </mat-toolbar>

  <!-- side nav starts -->
  <!-- [ngClass]="{'mat-sidenav-container-other': tabName==='home'}" -->
  <!-- home: the toolbar overlays the page, so the container stays full height even while the side menu is open
       (it used to drop to calc(100% - 80px) and leave an 80px white band at the bottom) -->
  <mat-sidenav-container class="flex-fill"
    [ngClass]="{'mat-sidenav-container-other': tabName==='home' || tabName==='' || tabName===null}">
    <!-- the sidenav reports its own state, so isSidenavOpen stays right however it's closed
         (backdrop tap, menu links, login/sign-up links), not only via the menu button -->
    <mat-sidenav #sidenav class="mob-nav-bg" (openedStart)="isSidenavOpen = true" (closedStart)="isSidenavOpen = false">
      <mat-nav-list class="{{tabName == '' ? 'mar-t-80':''}}">
        <!-- logged-in profile (the toolbar's profile block is desktop-only) -->
        <div *ngIf="authChecked && !!userInfo" class="side-profile flex align-c pad-l-30 mar-t-20">
          <ng-container *ngTemplateOutlet="profileIcon"></ng-container>
          <div class="flex flex-d-c mar-l-10 overflow-e line-16">
            <span class="font-14 f-w-500">{{userInfo.user_name}}</span>
            <span class="font-12">{{!!selectedCompany?.company_name?selectedCompany?.company_name:'---'}}</span>
          </div>
        </div>
        <div *ngFor="let item of menuList"
          class="{{item.link == 'tools' && showMenus.service == true ? 'mar-t-20':''}}
           {{item.link == 'contact-us' && showMenus.tools == true ? 'mar-t-20':''}} {{item.link == '/' ? 'mar-t-20':''}}">
          <a [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" *ngIf="!!item?.isroute"
            routerLink="{{item.link}}" class="nav-d pad-l-30 f-w-500 width-100 pos-r font-16-r"
            (click)="updateActiveSubtab(item.link);toggleSidenav()"
            style="height: 48px;justify-content: center;"
            appEventTracker="nav_{{item?.link}}" [module]="'navigation'" [eventAction]="'navigation'"
            [trackingData]="{to: item?.name, link: item?.link === '/' ? '' : item?.link}">{{item?.name}}

            <div class="active-d"></div>

          </a>

          <a *ngIf="!item?.isroute" role="button"
            class="nav-d width-100 f-w-500 pos-r font-16-r {{activeSubtab == item.key ? 'active': ''}}"
            (click)="handleMenuItemClick(item);">
            <div class="pad-l-30 flex align-c justify-space-between div-a f-w-500 ">
              <div class="pointer">{{item?.name}}</div>
              <!-- <div *ngIf="!item.isroute" class="flex align-c mar-r-10">
                <mat-icon>{{!showMenus[item.key] ? 'arrow_drop_down' : 'arrow_drop_up'}}</mat-icon>
              </div> -->
            </div>

            <div class="pos-r pad-lr-20 mar-t-10" *ngIf="!!showMenus.service && item.key === 'service'"
              style="left: -15px;width: 101.5%;margin-left: 20px;">
              <div class="pointer">Primary Services</div>
              <div *ngFor="let item of servicesData.primary" class="border-b border-cc pad-10 mar-t-10">
                <div class="pointer" routerLink="{{item.route}}" (click)="updateActiveSubtab(item.route);toggleSidenav()">
                  <div class="font-16 f-w-500 text-a-l s-title flex align-c pad-b-10">
                    <span class="material-symbols-outlined mar-r-10">{{item.icon}}</span>
                    {{item.title}}
                  </div>
                </div>
              </div>
              </div>


              <div class="pos-r pad-lr-20 mar-t-20" *ngIf="!!showMenus.service && item.key === 'service'"
                style="left: -15px;width: 101.5%;margin-left: 20px;">
                <div class="pointer">Additional Services</div>
                <div *ngFor="let item of servicesData.additional" class="border-b border-cc pad-10 mar-t-10">
                  <div class="pointer" routerLink="{{item.route}}" (click)="updateActiveSubtab(item.route);toggleSidenav()">
                    <div class="font-16 f-w-500 text-a-l s-title flex align-c pad-b-10">
                      <span class="material-symbols-outlined mar-r-10">{{item.icon}}</span>
                      {{item.title}}
                    </div>
                  </div>
                </div>
              </div>

            <div class="pos-r pad-lr-20" *ngIf="!!showMenus.tools && item.key === 'tools'"
              style="left: -15px;width: 101.5%;">
              <div *ngFor="let item of toolsSubTab" class="border-b border-cc pad-10 pad-b-10">
                <div class="flex align-c pointer" routerLink="{{item.route}}"
                  (click)="updateActiveSubtab(item.route);toggleSidenav();congetStartedMob(item.route)">
                  <img *ngIf="item.img" [ngStyle]="{'width':item.width}" src="{{item.img}}" [alt]="item.name + ' icon'"
                    class="{{item.name != 'Container Tracking' ? 'mar-r-10' : 'mar-r-5'}}">
                     <span *ngIf="item.icon && item.icon !== 'custom_half_arrows'" class="material-symbols-outlined" style="color: black;">
                      {{ item.icon }}
                    </span>
                    <svg *ngIf="item.icon === 'custom_half_arrows'" xmlns="http://www.w3.org/2000/svg" [style.width]="item.width"
                      [style.height]="item.width" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" class="mar-r-10">
                      <path d="M20 9H4l5-5"></path>
                      <path d="M4 15h16l-5 5"></path>
                    </svg>
                  <div class="pad-10 font-16 f-w-500 s-title">{{item?.name}}</div>
                </div>
              </div>
            </div>


            <div class="pos-r pad-lr-20" *ngIf="!!showMenus.resources && item.key === 'resources'"
              style="left: -15px;width: 101.5%;">
              <div *ngFor="let item of resourceTab" class="border-b border-cc pad-10 pad-b-10">
                <div class="flex align-c pointer" routerLink="{{item.route}}"
                  (click)="updateActiveSubtab(item.route);toggleSidenav();congetStartedMob(item.route)">
                  <!-- <img *ngIf="item.img" [ngStyle]="{'width':item.width}" src="{{item.img}}" alt="Icon"
                    class="{{item.name != 'Container Tracking' ? 'mar-r-10' : 'mar-r-5'}}"> -->
                     <span *ngIf="item.icon && item.icon !== 'custom_half_arrows'" class="material-symbols-outlined" style="color: black;">
                      {{ item.icon }}
                    </span>
                    <svg *ngIf="item.icon === 'custom_half_arrows'" xmlns="http://www.w3.org/2000/svg" [style.width]="item.width"
                      [style.height]="item.width" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" class="mar-r-10">
                      <path d="M20 9H4l5-5"></path>
                      <path d="M4 15h16l-5 5"></path>
                    </svg>
                  <div class="pad-10 font-16 f-w-500 s-title">{{item?.name}}</div>
                </div>
              </div>
            </div>

            <div class="pos-r pad-lr-20" *ngIf="!!showMenus.shippingLiners && item.key === 'shippingLiners'"
              style="left: -15px;width: 101.5%;">
              <div *ngFor="let liner of shippingLinersList" class="border-b border-cc pad-10 pad-b-10">
                <div class="flex align-c pointer" [routerLink]="'/port-to-port/' + liner.slug"
                  (click)="updateActiveSubtab('port-to-port/' + liner.slug);toggleSidenav()">
                  <img [src]="liner.logo" [alt]="liner.name" loading="lazy"
                    style="width:24px;height:24px;object-fit:contain;margin-right:10px;">
                  <div class="pad-10 font-16 f-w-500 s-title">{{liner.name}}</div>
                </div>
              </div>
            </div>

            <div class="bg-white pos-r pad-lr-20 mar-t-10" *ngIf="!!showMenus.company && item.key === 'company'"
              style="left: -15px;width: 101.5%;">
              <div *ngFor="let item of companySubTab">
                <div class="flex align-c  pointer color-b pad-5-10" routerLink="{{item.route}}"
                  (click)="updateActiveSubtab(item.route);sidenav.toggle()">
                  <div class="tab-icon" [ngStyle]="{'background-position':item.tb + ' ' + item.lr }"></div>
                  <div class="pad-10 font-12 subc-b">{{item?.name}}
                  </div>
                </div>
              </div>
            </div>

            <div class="active-d" style="top: 17px;"></div>
          </a>
        </div>
        <a (click)="sidenav.toggle();openQuote();" style="height: 48px;justify-content: center;"
          class="width-100 font-f-ovo f-w-600 nav-d pointer pad-l-30 font-16-r">Get a quote

          <div class="active-d"></div>
        </a>
        <a *ngIf="!userInfo" role="button" (click)="sidenav.toggle();login();" style="height: 48px;justify-content: center;"
          class="width-100 font-f-ovo f-w-500 nav-d pointer pad-l-30 font-16-r">Login

          <div class="active-d"></div>
        </a>
        <a *ngIf="!userInfo" role="button" (click)="sidenav.toggle();signup();" style="height: 48px;justify-content: center;"
          class="width-100 font-f-ovo f-w-500 nav-d pointer pad-l-30 font-16-r">Sign Up

          <div class="active-d"></div>
        </a>
        <a *ngIf="!!userInfo" role="button" (click)="sidenav.toggle();signout();" style="height: 48px;justify-content: center;"
          class="width-100 font-f-ovo f-w-500 nav-d pointer pad-l-30 font-16-r">Sign Out

          <div class="active-d"></div>
        </a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="flex-fill">
      <div #sidecontent id="sidecontent" class="width-100  height-100 {{!!isFooterNeeded?'overflow-a':'overflow-h'}}"
        cdkScrollable>
        <router-outlet></router-outlet>
        <app-footer *ngIf="isFooterNeeded"></app-footer>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-template>

<mat-menu #profileOptionMenu="matMenu">
  <!-- <button mat-menu-item class="head-c">My profile</button>
  <button mat-menu-item class="head-c">My settings</button>
  <button mat-menu-item class="head-c border-t border-b border-c">Account administration</button>
  <button mat-menu-item>Documentations</button> -->
  <button mat-menu-item class="head-c" (click)="signout()">Sign out</button>
  <button mat-menu-item class="primary-c" (click)="navigatePortal()">Open Portal</button>
</mat-menu>

<ng-template #profileIcon>
  <img loading="lazy" src="https://app.atmavaan.com/uploads/{{userInfo?.photo}}" width="32px" height="32px"
    alt="{{userInfo?.user_name}}" style="border-radius: 50%;object-fit: cover;" *ngIf="userInfo?.photo">
  <svg xmlns=" http://www.w3.org/2000/svg" viewBox="0 0 212 212" height="30" width="30" *ngIf="!userInfo?.photo">
    <path fill="#DFE5E7" class="background"
      d="M106.251.5C164.653.5 212 47.846 212 106.25S164.653 212 106.25 212C47.846 212 .5 164.654.5 106.25S47.846.5 106.251.5z">
    </path>
    <path fill="#FFF" class="primary"
      d="M173.561 171.615a62.767 62.767 0 0 0-2.065-2.955 67.7 67.7 0 0 0-2.608-3.299 70.112 70.112 0 0 0-3.184-3.527 71.097 71.097 0 0 0-5.924-5.47 72.458 72.458 0 0 0-10.204-7.026 75.2 75.2 0 0 0-5.98-3.055c-.062-.028-.118-.059-.18-.087-9.792-4.44-22.106-7.529-37.416-7.529s-27.624 3.089-37.416 7.529c-.338.153-.653.318-.985.474a75.37 75.37 0 0 0-6.229 3.298 72.589 72.589 0 0 0-9.15 6.395 71.243 71.243 0 0 0-5.924 5.47 70.064 70.064 0 0 0-3.184 3.527 67.142 67.142 0 0 0-2.609 3.299 63.292 63.292 0 0 0-2.065 2.955 56.33 56.33 0 0 0-1.447 2.324c-.033.056-.073.119-.104.174a47.92 47.92 0 0 0-1.07 1.926c-.559 1.068-.818 1.678-.818 1.678v.398c18.285 17.927 43.322 28.985 70.945 28.985 27.678 0 52.761-11.103 71.055-29.095v-.289s-.619-1.45-1.992-3.778a58.346 58.346 0 0 0-1.446-2.322zM106.002 125.5c2.645 0 5.212-.253 7.68-.737a38.272 38.272 0 0 0 3.624-.896 37.124 37.124 0 0 0 5.12-1.958 36.307 36.307 0 0 0 6.15-3.67 35.923 35.923 0 0 0 9.489-10.48 36.558 36.558 0 0 0 2.422-4.84 37.051 37.051 0 0 0 1.716-5.25c.299-1.208.542-2.443.725-3.701.275-1.887.417-3.827.417-5.811s-.142-3.925-.417-5.811a38.734 38.734 0 0 0-1.215-5.494 36.68 36.68 0 0 0-3.648-8.298 35.923 35.923 0 0 0-9.489-10.48 36.347 36.347 0 0 0-6.15-3.67 37.124 37.124 0 0 0-5.12-1.958 37.67 37.67 0 0 0-3.624-.896 39.875 39.875 0 0 0-7.68-.737c-21.162 0-37.345 16.183-37.345 37.345 0 21.159 16.183 37.342 37.345 37.342z">
    </path>
  </svg>
</ng-template>


<!-- loaded once the page is idle, so the chatbot isn't part of the first download -->
@defer (on idle) {
  <app-chatbot-widget> </app-chatbot-widget>
}